/**
 * shouldForwardProp helper for MUI styled() to hide all `$` prefixed props from DOM
 *
 * Usage: styled('div', { shouldForwardProp })<{ $propname: type }>((props) => ({ ... }))
 */
export const shouldForwardProp = (propName) => propName[0] !== '$';
